/**
* 班级内人员列表
*/
<template>
    <span>
        <a-button @click="openmodel()" type="primary">
            添加
        </a-button>
        <a-modal :visible="visible" :width="1280" title="章节试卷详情2" @ok="okmodel" @cancel="cancelmodel">
            <a-form layout="inline">
				
                <a-form-item>
                    <a-tree-select v-model="searchFrom.type_id" :treeData="typelist" style="width: 150px;"
                        :replaceFields="{children:'children',title:'name',key:'name',value:'id'}" placeholder="选择试卷分类"
                        tree-default-expand-all allowClear></a-tree-select>
                </a-form-item>
                <a-form-item>
                    <a-select v-model="searchFrom.grade_id" placeholder="年级" style="width: 120px;">
                        <a-select-option value>全部</a-select-option>
                        <a-select-option v-for="(item) in gradeList" :key="item.id" :value="item.id">{{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item>
                    <a-select v-model="searchFrom.semester_id" placeholder="学期" style="width: 120px;">
                        <a-select-option value>全部</a-select-option>
                        <a-select-option v-for="(item) in semesterList" :key="item.id" :value="item.id">{{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item>
                    <a-input placeholder="试卷名字" v-model="searchFrom.keyword" @keyup.enter="tableSearch"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" htmlType="submit" icon="search" @click="tableSearch"></a-button>
                </a-form-item>
            </a-form>
            <a-divider></a-divider>
            <div>
                <a-table :dataSource="datalist" :rowKey="item => item.id" :pagination="pageinfo" :loading="loading"
                    @change="onPaginationChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" bordered>
                   <a-table-column key="name" title="试卷名称" data-index="name" />
                   <a-table-column key="typename" title="试卷类型" data-index="typename" />
                   <a-table-column key="nickname" title="创建人" data-index="nickname" />
                   <a-table-column key="create_time" title="创建时间" data-index="create_time" />
                    <!-- <a-table-column key="action" title="操作">
                       <template slot-scope="text, record">
                           <span>
                               <a @click="shengchengmission(record.id)">查看</a>
                           </span>
                       </template>
                   </a-table-column> -->
                    <!-- <a-table-column key="type" title="班型">
                        <template slot-scope="item">
                            <span v-if="item.type==0">培优班</span>
                            <span v-if="item.type==1">提高班</span>
                            <span v-if="item.type==2">英才班</span>
                            <span v-if="item.type==3">1对1VIP班</span>
                        </template>
                    </a-table-column> -->
                    <!-- <a-table-column key="opening" title="开班状态">
                        <template slot-scope="item">
                            <span v-if="item.opening==0">未开班</span>
                            <span v-if="item.opening==1">已开班</span>
                            <span v-if="item.opening==2">已结班</span>
                        </template>
                    </a-table-column> -->
                </a-table>
                <div>总共{{pageinfo.total}}条数据</div>
            </div>

        </a-modal>
    </span>

</template>
<script>
    export default {
        components: {},
        props: {
            itemdata: {},
            mission_id: [],
        },
        data() {
            return {
                data: [],
                pageinfo: {
                    total: 1,
                    current: 1,
                    pageSize: 10
                },
                selectedRowKeys: [], 
                searchFrom: {
                    keyword: undefined,
                    semester_id: undefined,
                    grade_id: undefined,
                    type_id: undefined
                },
                datalist: [],
                loading: false,
                visible: false,
                 typelist: [],
                 gradeList:[],
                 semesterList:[],
            };
        },
        mounted() {
            this.getTestpaperTypeList();
            this.getGradeList();
            this.getSemesterList();
        },
        computed: {
           
        },
        methods: {
            onSelectChange(selectedRowKeys) {
                 // console.log('selectedRowKeys changed: ', selectedRowKeys);
                  this.selectedRowKeys = selectedRowKeys;
                },
            getTestpaperTypeList() {
                this.$axios
                    .post("/api/QuestionTestpaperType/index")
                    .then((res) => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            });
                        } else {
                            this.typelist = res.data;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            },
            getGradeList() {
                this.$axios
                    .post("/api/BasicGrade/index")
                    .then(res => {
                        if (res.code == 200) {
                            this.gradeList = res.data.data;
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            getSemesterList() {
                this.$axios
                    .post("/api/BasicSemester/index")
                    .then(res => {
                        if (res.code == 200) {
                            this.semesterList = res.data.data;
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            tableSearch() {
                this.pageinfo.current = 1;
                this.getTableList(this.searchFrom);
            },
            getTableList(data) {
                this.loading = true;
                this.$axios
                    .post("/api/QuestionTestpaper/index", {
                        data: data,
                        pageinfo: this.pageinfo
                    })
                    .then(res => {
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定"
                            });
                            this.squaduserlist = null;
                        } else {
                            this.datalist = res.data.data;
                            this.pageinfo = res.data.pageinfo;
                        }
                    })
                    .catch(err => {
                        console.error(err);
                    }).finally(() => {
                        this.loading = false;
                    })
            },

            openmodel() {
                this.visible = true;
				this.getTestpaperTypeList();
				this.getGradeList();
				this.getSemesterList();
                this.getTableList(this.searchFrom);
            },
            okmodel() {
                this.visible = false;
                this.$emit('testpaperkeys', this.selectedRowKeys);
            },
            cancelmodel() {
                this.visible = false;
               // this.searchFrom=[];
               this.pageinfo.current = 1;
                this.selectedRowKeys=[];
              
            },

            onPaginationChange(item) {
                this.pageinfo.current = item.current;
                this.getTableList(this.searchFrom);
            },


        }
    };
</script>
<style>
    .active_btn {
        margin-left: 5px;
    }
</style>
